import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { BusinessIDVSettings } from '@models/businessSettings/settings';
import { IDVProvider } from '@models/idv';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { NavigationService } from '@services/nav/nav.service';
import { UrlService } from '@services/url/url.service';
import { BusinessDispatch, BusinessState } from '@state/business';
import { BusinessUsersDispatch } from '@state/business-users/business-users.dispatch';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import {
	TreefortOnboardingModalComponent,
	TreefortOnboardingModalData,
} from './treefort-onboarding-modal/treefort-onboarding-modal.component';

@Component({
	selector: 'app-treefort',
	templateUrl: './treefort.component.html',
	styleUrls: ['./treefort.component.scss'],
	standalone: false,
})
export class TreefortProfileComponent {
	@ViewSelectSnapshot(BusinessState.getIDVProviderSelected)
	idvProviderSelected: IDVProvider;
	@SelectSnapshot(BusinessUsersState.isLoggedInUserAdmin)
	isLoggedInUserAdmin: boolean;
	public ICON = ICON;
	public idvProvider = IDVProvider;
	public benefits = [
		'Save time by initiating IDV requests simultaneously for all parties on a file',
		'Receive automated updates regarding the status of IDV requests',
		'Obtain Treefort-certified identity verification',
		'Share completed IDV report details with title insurers and lenders',
	];

	public idvListUrl = UrlService.IDVList();
	public idvSettingsUrl = UrlService.Manage_Finances_General();
	public treefortUrl =
		'https://treeforttech.com/user-license-agreement/#:~:text=not%20to%20upload%20to%2C%20distribute,any%20intellectual%20property%20or%20other';

	constructor(
		private navService: NavigationService,
		private businessDispatch: BusinessDispatch,
		private businessUsersDispatch: BusinessUsersDispatch,
		private matDialog: MatDialog,
	) {}

	goToIntegrations(): void {
		this.navService.goToProfile_Integrations();
	}

	openTreefortOnboardingModal() {
		const data: TreefortOnboardingModalData = {
			primaryButtonText: 'Agree & Connect',
		};

		this.matDialog.open(TreefortOnboardingModalComponent, {
			width: '40rem',
			maxWidth: '1000px',
			data,
		});
	}

	disconnectTreefortIntegration(): void {
		this.businessDispatch.UpdateDefaultSettings({
			idv: { defaultProvider: IDVProvider.MANUAL } as BusinessIDVSettings,
		});
	}

	goToMyTreefortReports(event: MouseEvent): void {
		event.preventDefault();
		this.navService.goToIDVList();
	}

	shouldRenderReportLinks(): boolean {
		return this.idvProviderSelected === IDVProvider.TREEFORT;
	}

	get renderTooltipString(): string | null {
		return this.isLoggedInUserAdmin
			? null
			: 'Contact your account admin to connect to Treefort.';
	}
}
